import { Box,Grid2, InputLabel, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useNavigate } from 'react-router-dom';
import MUICancelButton from '../../reusable_components/components/MuiCancelButton';
import MUIButton from '../../reusable_components/components/MUIButton';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { useViewRecruiterDetailsByIdQuery } from '../../redux/Profile/profile.api';
import DescriptionIcon from '@mui/icons-material/Description';
import { useSelector } from 'react-redux';
import { MdDelete } from "react-icons/md";

const FileLink = ({ filePath, displayName }) => {
    // Remove the unwanted part of the file path
    const cleanFilePath = filePath?.replace(/^.*\/html/, window.REACT_APP_FILEDOWNLOAD_URL);
    // const cleanFilePath = filePath?.replace(/^.*\/html/, 'https://stage-or.g-axis.in');

    const fileNameWithExtension = filePath?.split('/').pop();
    const getIconByExtension = (filePath) => {
        const extension = filePath?.split(".").pop().toLowerCase();
        switch (extension) {
            case "docx":
            case "doc":
                return <DescriptionIcon style={{ marginRight: "8px", color: "#1E88E5" }} />;
            case "pdf":
                return <DescriptionIcon style={{ marginRight: "8px", color: "#FF5252" }} />;
            default:
                return <DescriptionIcon style={{ marginRight: "8px", color: "#555" }} />;
        }
    };

    const handleClick = (e) => {
        e.preventDefault(); // Prevent default anchor behavior
        window.open(cleanFilePath, "_blank");
    };

    return (
        <>
            <Typography variant="body2" style={{ marginBottom: "5px", fontWeight: 500 }}>
                {displayName} {/* Display name above the file link */}
            </Typography>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    border: "1px solid grey",
                    borderRadius: "8px",
                    padding: "7px 14px",
                    maxWidth: "100%", // Prevents overflow
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    background: "#F9F9F9", // Light background for a card-like look
                }}
            >
                {getIconByExtension(filePath)}
                <a
                    href="#"
                    onClick={handleClick}
                    style={{
                        textDecoration: "none",
                        color: "#007BFF",
                        marginLeft: "10px",
                        flex: 1, // Ensures text takes remaining space
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        fontWeight: 500,
                    }}
                    title={fileNameWithExtension} // Show full name on hover
                >
                    {fileNameWithExtension}
                </a>
            </div>
        </>
    );
};


const ViewProfile = ({handleOpenDelete}) => {
    const navigate = useNavigate();
    const theme1 = useTheme()
    const isSmallScreen = useMediaQuery(theme1.breakpoints.down('md'))

    const { data: ViewRecruiterDetailsById, refetch } = useViewRecruiterDetailsByIdQuery();

    const { Profile } = useSelector((state) => state.common);
    const levelSecondApprove = Profile?.profile?.levelTwoApproval

    useEffect(() => {
        refetch()
    }, [])

    const handleProfileEdit = () => {
        navigate("/profile")
    };

    const files = [
        {
            filePath: ViewRecruiterDetailsById?.response?.data[0]?.resumeFile,
            displayName: "Resume",
        },
        {
            filePath: ViewRecruiterDetailsById?.response?.data[0]?.companyProfileFile,
            displayName: "Company Profile",
        },
        {
            filePath: ViewRecruiterDetailsById?.response?.data[0]?.aadhaarcardFile,
            displayName: "Aadhaar Card",
        },
        {
            filePath: ViewRecruiterDetailsById?.response?.data[0]?.pancardFile,
            displayName: "PAN Card",
        },
        {
            filePath: ViewRecruiterDetailsById?.response?.data[0]?.bankCancelledChequeFile,
            displayName: "Bank Cancelled Cheque",
        },
    ];
    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate('/jobpost')}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Box>
                    <Typography className="title" sx={{}}>{ViewRecruiterDetailsById?.response?.data[0]?.name}</Typography>
                    <Typography className="subTitle" sx={{}}>{ViewRecruiterDetailsById?.response?.data[0]?.companyName}</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <MUIButton title='Edit' className="edit-button" onClick={handleProfileEdit} />
                    <MUICancelButton title='Delete Account' startIcon={<MdDelete sx={{ fontSize: '15px !important' }} />} sx={{ color: '#fff', background: '#c60606ff' }} onClick={handleOpenDelete} />
                </Box>
            </Box>

            {ViewRecruiterDetailsById?.response?.data?.[0]?.secondLevelReasonDesc && (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography sx={{ color: 'red', fontWeight: 600 }}>{ViewRecruiterDetailsById?.response?.data?.[0]?.secondLevelReasonDesc}</Typography>
                </Box>
            )}

            <Box sx={{ marginTop: "10px", display: 'flex', width: '100%', gap: '30px' }}>
                <Grid2 container sx={{ display: 'flex', width: '55%', flexDirection: 'column' }}>
                    <div>
                        <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                            Overview
                        </Typography>
                    </div>
                    <div style={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', marginTop: '10px' }}>
                        <Grid2 item container sx={{ display: 'flex', flexDirection: 'column' }} gap={2}>
                            <Box>
                                <InputLabel>Email</InputLabel>
                                <Typography variant="body3" sx={{ color: '#6941C6' }}>{ViewRecruiterDetailsById?.response?.data[0]?.email}</Typography>
                            </Box>

                            <Box>
                                <InputLabel>Date of birth</InputLabel>
                                <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.dob}</Typography>
                            </Box>

                            <Box>
                                <InputLabel>Alternate Number</InputLabel>
                                <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.alternateContactNumber}</Typography>
                            </Box>

                        </Grid2>

                        <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '45%' }} gap={2}>
                            <Box>
                                <InputLabel>Contact Number</InputLabel>
                                <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.contactNumber}</Typography>
                            </Box>

                            <Box>
                                <InputLabel>Gender</InputLabel>
                                <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.gender}</Typography>
                            </Box>

                            <Box>
                                <InputLabel>Address</InputLabel>
                                <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.street}</Typography>
                            </Box>

                        </Grid2>
                    </div>
                    {levelSecondApprove === 'Y' && (
                        <>
                            <div style={{ marginTop: "10px" }}>
                                <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                    Career details
                                </Typography>
                            </div>

                            <div style={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', marginTop: '10px' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column' }} gap={2}>
                                    <Box>
                                        <InputLabel>Current designation</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.currentDesignation}</Typography>
                                    </Box>
                                    <Box>
                                        <InputLabel>Specialization</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.specification}</Typography>
                                    </Box>
                                </Grid2>

                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '45%' }} gap={2}>

                                    <Box>
                                        <InputLabel>Years of experience</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.yearsOfExperience}</Typography>
                                    </Box>

                                    <Box>
                                        <InputLabel>Linkedin profile</InputLabel>
                                        <a
                                            href={
                                                ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile?.startsWith('http')
                                                    ? ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile
                                                    : `https://${ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile}`
                                            }
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            style={{ color: '#6941C6', textDecoration: 'none' }}
                                        >
                                            {(ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile) === null ? '---' : "Profile Link"}
                                        </a>

                                    </Box>
                                </Grid2>
                            </div>

                            <Box style={{ marginTop: "8px" }}>
                                <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                    Aadhar/PAN
                                </Typography>
                            </Box>

                            <div style={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', marginTop: '10px' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column' }} gap={2}>
                                    <Box>
                                        <InputLabel>Aadhar number</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.aadhaarNumber}</Typography>
                                    </Box>

                                </Grid2>

                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '45%' }} gap={2}>

                                    <Box>
                                        <InputLabel>PAN number</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.panNumber}</Typography>
                                    </Box>
                                </Grid2>
                            </div>
                        </>
                    )}
                </Grid2>

                {levelSecondApprove === 'Y' && (
                    <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between', width: '35%' }}>
                        <Grid2>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
                                <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                    Bank details
                                </Typography>
                            </Box>

                            <div style={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', marginTop: '10px' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column' }} gap={2}>
                                    <Box>
                                        <InputLabel>Account name</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.recruiterAccountName}</Typography>
                                    </Box>

                                    <Box>
                                        <InputLabel>Bank name</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.bankName}</Typography>
                                    </Box>

                                    <Box>
                                        <InputLabel>IFSC code</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.ifscCode}</Typography>
                                    </Box>

                                </Grid2>

                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '10%' }} gap={2}>

                                    <Box>
                                        <InputLabel>Account number</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.aadhaarNumber}</Typography>
                                    </Box>

                                    <Box>
                                        <InputLabel>Branch name</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.branch}</Typography>
                                    </Box>
                                </Grid2>
                            </div>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
                                <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                    Documents
                                </Typography>
                            </Box>

                            <div style={{ marginTop: '8px' }}>
                                {files?.map((file, index) => (
                                    <FileLink
                                        key={index}
                                        filePath={file.filePath}
                                        displayName={file.displayName}
                                    />
                                ))}
                            </div>

                        </Grid2>

                    </Grid2>
                )}
            </Box>
        </Box>
    )
}

export default ViewProfile;